import { createContext, useContext } from "react";
import type { Socket } from "socket.io-client";

interface SocketContextValue {
  socket: Socket | null;
  fitnessCenterId: string | null;
  isConnected: boolean;
  messageChangeListenerReady: boolean;
  reconnect: () => void;
}

export const SocketContext = createContext<SocketContextValue>({
  socket: null,
  fitnessCenterId: null,
  isConnected: false,
  messageChangeListenerReady: false,
  reconnect: () => {},
});

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within SocketProvider");
  }
  return context;
};
